














import {Component, Vue, Emit} from 'vue-property-decorator';
import {KeyValidatorUtil} from '@/utils/KeyValidatorUtil';
import {SshKey} from '@/interfaces/interfaces';
import {Getter} from 'vuex-class';

@Component
export default class AddBox extends Vue {
  @Getter availableKeyPairs?: SshKey[];
  newKeyValue = '';
  warningMessage = '';

  @Emit('submit')
  submit() {
    let keyPair = '';
    this.warningMessage = '';

    if (this.isDuplicateKey()) {
      this.warningMessage = 'Identical key already exists!';
    } else if (KeyValidatorUtil.hasOpenSSHFormat(this.newKeyValue)) {
      keyPair = this.newKeyValue;
      this.warningMessage = '';
      this.newKeyValue = '';
    } else {
      this.warningMessage = 'Public key is not formatted by OpenSSH!';
    }

    return keyPair;
  }

  private isDuplicateKey(): boolean | undefined {
    const newKey = this.removeComment(this.newKeyValue);
    return this.availableKeyPairs?.some((keyPair) => this.removeComment(keyPair.value) === newKey);
  }

  private removeComment(key: string): string {
    let processedKey = key.trim();
    const commentStartIndex = processedKey.indexOf(' ', processedKey.indexOf(' ') + 1);
    if (commentStartIndex > 0) {
      processedKey = processedKey.substr(0, commentStartIndex);
    }
    return processedKey;
  }
}
